import type { CallDirection } from 'store/call/call.state';

import VoiceInboundIcon from 'images/icon-voice-inbound-white.svg';
import VoiceOutboundIcon from 'images/icon-voice-outbound-white.svg';

const getCallDirectionIcon = (callDirection: CallDirection) => {
    let callDirectionIcon: string | undefined;

    switch (callDirection) {
        case 'inbound':
            callDirectionIcon = VoiceInboundIcon;
            break;
        case 'outbound':
            callDirectionIcon = VoiceOutboundIcon;
            break;
        case 'transfer':
            callDirectionIcon = VoiceOutboundIcon;
            break;
    }

    return callDirectionIcon;
};

export { getCallDirectionIcon };
